















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { IIssue, IUser } from '@/lib/interfaces';
import { mapState } from 'vuex';
import { isTouch } from '@/lib/helpers/common.helper';

@Component({
  computed: mapState(['users']),
})
export default class IssueRow extends Vue {
  /** users from vuex */
  public users!: { string: IUser };
  private isTouch = isTouch();

  @Prop() private issue!: IIssue;
  @Prop({ type: Boolean, default: true }) private showAvatars!: boolean;
  @Prop({ type: Boolean, default: false }) private showCompleteDate!: boolean;
  @Prop({ type: Boolean, default: false }) private showDelete!: boolean;
  @Prop({ type: Boolean, default: false }) private withPrior!: boolean;

  private get completed(): boolean {
    return this.issue.status === 'Готово';
  }

  private deleteIssue(): void {
    if (confirm('Вы действительно хотите удалить тикет?')) {
      this.$emit('onDelete', this.issue);
    }
  }
}
